import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { getSupabaseAdmin } from "@/integrations/external-supabase/client.server";
import { requireAdmin } from "@/lib/auth-guards.server";

export const findAgenciasByEmailSubject = createServerFn({ method: "POST" })
  .inputValidator((d: unknown) =>
    z.object({ subject: z.string().trim().min(1).max(300) }).parse(d),
  )
  .handler(async ({ data }) => {
    await requireAdmin();
    const sb = getSupabaseAdmin();

    const like = `%${data.subject.replace(/[%_]/g, (m) => `\\${m}`)}%`;
    const { data: rows, error } = await sb
      .from("comunicaciones")
      .select("meta_data")
      .eq("channel", "email")
      .eq("direction", "outbound")
      .filter("meta_data->>subject", "ilike", like)
      .limit(20000);
    if (error) throw new Error(error.message);

    const emails = new Set<string>();
    for (const r of rows ?? []) {
      const to = (r.meta_data as { to?: string } | null)?.to;
      if (to && typeof to === "string") emails.add(to.trim().toLowerCase());
    }
    if (emails.size === 0) return { agencias: [] as Array<{ nombre: string; telefono: string | null; email: string | null }>, matched_emails: 0 };

    const list = Array.from(emails);
    const found = new Map<string, { nombre: string; telefono: string | null; email: string | null }>();
    const CHUNK = 150;
    for (let i = 0; i < list.length; i += CHUNK) {
      const chunk = list.slice(i, i + CHUNK);
      const { data: ags, error: eAg } = await sb
        .from("agencias")
        .select("nombre, telefono, email")
        .in("email", chunk);
      if (eAg) throw new Error(eAg.message);
      for (const a of ags ?? []) {
        const key = (a.email ?? "").toLowerCase();
        if (!found.has(key)) found.set(key, a);
      }
    }

    return {
      agencias: Array.from(found.values()).sort((a, b) => a.nombre.localeCompare(b.nombre)),
      matched_emails: emails.size,
    };
  });

export const recountContadores = createServerFn({ method: "POST" }).handler(async () => {
  await requireAdmin();
  const sb = getSupabaseAdmin();
  const { error } = await sb.rpc("recount_contadores" as any);
  if (error) throw new Error(error.message);
  return { ok: true };
});
